import {Service} from "@/services/superclasses/service";
import {CommentList} from "@/interfaces/comment-list";
import {FormResponse} from "@/interfaces/form-response";
import {CommentCreate} from "@/interfaces/comment-create";
import {CommentUpdate} from "@/interfaces/comment-update";

const api = window.contextPath + '/rest/comments';

export class CommentService extends Service {

    public prepareNew = async (): Promise<CommentCreate> => {
        return this.data(await this.get<CommentCreate>(api + "/prepare-new"))
    };

    public create = async (data: CommentCreate): Promise<FormResponse<CommentList>> => {
        return this.data(await this.post<FormResponse<CommentList>>(api, data))
    }

    public update = async (id: number, data: CommentUpdate): Promise<FormResponse<CommentList>> => {
        return this.data(await this.put<FormResponse<CommentList>>(api + "/" + id, data))
    }

    public manage = async (id: number, emailToken: string): Promise<CommentUpdate> => {
        return this.data(await this.get<CommentUpdate>(api + "/" + id + "/" + emailToken))
    };

    public search = async (args: {
        articleId: number,
        emailToken?: string,
        first?: number,
        max?: number
    }): Promise<CommentList[]> => {
        return this.data(await this.get<CommentList[]>(api,
            {
                params: args
            }))
    }

    public count = async (args: {
        articleId: number
    }): Promise<number> => {
        return this.data(await this.get<number>(api + "/count",
            {
                params: args
            }))
    }
}

export const commentService = new CommentService()